<label class="base-input-label w-full" [ngClass]="{ 'opacity-50': disabled }">

    <p>{{ label }}<span *ngIf="required">*</span></p>

    <input
        [matDatepicker]="picker"
        class="base-text-input" 
        [value]="value"
        [disabled]="disabled"
        (click)="picker.open()"
        [placeholder]="placeholder"
        (dateInput)="addEvent('input', $event)">

    <a (click)="picker.open()" [ngClass]="{ 'datepicker-toggle': label, 'datepicker-toggle-no-label': !label }">
        <mat-icon class="md-18 text-gray-light">calendar_today</mat-icon>
    </a>

    <mat-datepicker #picker></mat-datepicker>
</label>